import React from 'react';

import {inputType} from '../interface/inputType';

export const headerLabelContainer = (
  headingType:
    | inputType.HEADING
    | inputType.HEADING_1
    | inputType.HEADING_2
    | inputType.HEADING_3
    | inputType.HEADING_4
    | inputType.HEADING_5,
  label: string
): React.ReactNode => {
  switch (headingType) {
    case inputType.HEADING:
      return <h4>{label}</h4>;
    case inputType.HEADING_1:
      return <h1>{label}</h1>;
    case inputType.HEADING_2:
      return <h2>{label}</h2>;
    case inputType.HEADING_3:
      return <h3>{label}</h3>;
    case inputType.HEADING_4:
      return <h4>{label}</h4>;
    case inputType.HEADING_5:
      return <h5>{label}</h5>;
    default:
      return label;
  }
};
